<div class="container-fluid" *ngIf="tripDetails">
  <!-- TRIP HEADER -->
  <div class="card mb-3 shadow-sm">
    <div class="card-body d-flex justify-content-between align-items-center">
      <div>
        <h5 class="mb-1">
          Trip Code: {{ tripDetails.tripCode }}
          <span
            class="badge"
            [ngClass]="{
              'bg-warning': tripDetails.status === 1,
              'bg-success':
                tripDetails.status === 2 || tripDetails.status === 3,
              'bg-primary': tripDetails.status === 4,
              'bg-danger': tripDetails.status === 5 || tripDetails.status === 6
            }"
          >
            {{ statusMap[tripDetails.status] }}
          </span>
        </h5>
        <small class="text-muted">
          Created: {{ tripDetails.createdAt | date : "medium" }}
        </small>
      </div>

      <!-- <div class="mb-3">
        <button class="btn btn-primary" (click)="goBack()">← Back</button>
      </div> -->

      <div class="mb-3 d-flex gap-2">
  <button
    class="btn btn-success"
    (click)="exportSingleTripToExcel()"
  >
    ⬇ Export
  </button>

  <button
    class="btn btn-primary"
    (click)="goBack()"
  >
    ← Back
  </button>
</div>

    </div>
  </div>

  <!-- ENTERPRISE DETAILS -->
  <div class="card mb-3 shadow-sm">
    <div class="card-header fw-bold">Enterprise Details</div>
    <div class="card-body row">
      <div class="col-md-6 mb-2">
        <b>Email:</b> {{ tripDetails.enterpriseDetails?.email }}
      </div>
      <div class="col-md-6 mb-2">
        <b>Phone:</b> {{ tripDetails.enterpriseDetails?.phone }}
      </div>
      <div class="col-md-6 mb-2">
        <b>GST Number:</b> {{ tripDetails.enterpriseDetails?.gstNumber }}
      </div>
      <div class="col-md-6 mb-2">
        <b>Address:</b> {{ tripDetails.enterpriseDetails?.address }}
      </div>
    </div>
  </div>

  <!-- VEHICLE & FARE -->
  <div class="card mb-3 shadow-sm">
    <div class="card-header fw-bold">Vehicle & Fare Details</div>
    <div class="card-body row align-items-center">
      <div class="col-md-3 text-center">
        <img
          [src]="tripDetails.estimatedCost?.data?.vehicleImage"
          class="img-fluid rounded"
        />
      </div>

      <div class="col-md-9 row">
        <div class="col-md-6 mb-2">
          <b>Vehicle Type:</b>
          {{ tripDetails.estimatedCost?.data?.vehicleType }}
        </div>
        <div class="col-md-6 mb-2">
          <b>Capacity:</b>
          {{ tripDetails.estimatedCost?.data?.vehicleCapacity }} kg
        </div>
        <div class="col-md-6 mb-2">
          <b>Dimensions:</b>
          {{ tripDetails.estimatedCost?.data?.vehicleDimensions }}
        </div>
        <div class="col-md-6 mb-2">
          <b>Duration:</b>
          {{ tripDetails.estimatedCost?.data?.totalDuration }} mins
        </div>
        <div class="col-md-6 mb-2 text-success">
          <b>Total Amount:</b>
          ₹{{ tripDetails.paymentDetails?.billDetails?.totalAmount }}
        </div>
        <div class="col-md-6 mb-2 text-success">
          <b>Driver Amount:</b>
          ₹{{ tripDetails.driverReceivingAmount }}
        </div>
      </div>
    </div>
  </div>

  <!-- PAYMENT DETAILS -->
  <div class="card mb-3 shadow-sm">
    <div class="card-header fw-bold">Payment Details</div>
    <div class="card-body row">
      <div class="col-md-3">
        <b>Total:</b>
        ₹{{ tripDetails.paymentDetails?.billDetails?.totalAmount }}
      </div>
      <div class="col-md-3">
        <b>Net Fare:</b>
        ₹{{ tripDetails.paymentDetails?.billDetails?.netFare }}
      </div>
      <div class="col-md-3">
        <b>Method:</b>
        {{ tripDetails.paymentDetails?.paymentMethod }}
      </div>
      <div class="col-md-3">
        <b>Status:</b>
        {{ paymentStatus[tripDetails.paymentDetails?.paymentStatus] }}
      </div>
    </div>
  </div>

  <!-- DRIVER DETAILS -->
  <div class="card mb-3 shadow-sm">
    <div class="card-header fw-bold">Driver Details</div>
    <div class="card-body row">
      <div class="col-md-4 mb-2">
        <b>Name:</b>
        {{ tripDetails.driverDetails?.firstName }}
        {{ tripDetails.driverDetails?.lastName }}
      </div>
      <div class="col-md-4 mb-2">
        <b>Phone:</b>
        {{ tripDetails.driverDetails?.phoneNumber }}
      </div>
      <div class="col-md-4 mb-2">
        <b>Vehicle No:</b>
        {{ tripDetails.driverDetails?.vehicleNumber }}
      </div>
    </div>
  </div>

  <!-- FROM LOCATION (0th STOP) -->
  <div class="card mb-3 shadow-sm" *ngIf="tripDetails.stops?.length">
    <div class="card-header fw-bold text-primary">From Location</div>
    <div class="card-body">
      <h6 class="mb-1">{{ tripDetails.stops[0].name }}</h6>
      <p class="text-muted mb-2">
        {{ tripDetails.stops[0].address }}
      </p>

      <div class="row">
        <div class="col-md-4">
          <b>Contact:</b> {{ tripDetails.stops[0].contactName }}
        </div>
        <div class="col-md-4">
          <b>Phone:</b> {{ tripDetails.stops[0].contactPhone }}
        </div>
        <div class="col-md-4">
          <b>Pick up Pin:</b> {{ tripDetails.stops[0].otpCode }}
        </div>
      </div>
    </div>
  </div>

  <!-- DROP LOCATIONS (EXCEPT 0th STOP) -->
  <!-- <div class="card mb-3 shadow-sm">
    <div class="card-header fw-bold">Drop Locations</div>

    <div class="card-body">
      <div
        *ngFor="let stop of tripDetails.stops.slice(1); let i = index"
        class="border rounded p-3 mb-3"
      >
        <div class="d-flex justify-content-between">
          <h6 class="mb-1">Stop {{ i + 1 }} - {{ stop.name }}</h6>

          <span
            class="badge"
            [ngClass]="{
              'bg-warning': stop.status === 1,
              'bg-success': [2, 3].includes(stop.status),
              'bg-danger': stop.status === 4
            }"
          >
            {{ stopStatus[stop.status] }}
          </span>
        </div>

        <p class="text-muted mb-2">
          {{ stop.address }}
        </p>

        <div class="row">
          <div class="col-md-4"><b>Contact:</b> {{ stop.contactName }}</div>
          <div class="col-md-4"><b>Phone:</b> {{ stop.contactPhone }}</div>
          <div class="col-md-4">
            <b>Collection Amount:</b> ₹{{ stop.amount }}
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-4">
            <b>Distance:</b> {{ stop.segmentDistance }} km
          </div>
          <div class="col-md-4"><b>OTP:</b> {{ stop.otpCode }}</div>
          <div class="col-md-4" *ngIf="stop.deliveredAt">
            <b>Delivered:</b> {{ stop.deliveredAt | date : "short" }}
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="card mb-3 shadow-sm">
  <div class="card-header fw-bold">Drop Locations</div>

  <div class="card-body">
    <div
      *ngFor="let stop of tripDetails.stops.slice(1); let i = index"
      class="border rounded p-3 mb-3"
    >
      <div class="d-flex justify-content-between">
        <h6 class="mb-1">Stop {{ i + 1 }} - {{ stop.name }}</h6>

        <span
          class="badge"
          [ngClass]="{
            'bg-warning': stop.status === 1,
            'bg-success': [2, 3].includes(stop.status),
            'bg-danger': stop.status === 4
          }"
        >
          {{ stopStatus[stop.status] }}
        </span>
      </div>

      <p class="text-muted mb-2">
        {{ stop.address }}
      </p>

      <div class="row">
        <div class="col-md-4"><b>Contact:</b> {{ stop.contactName }}</div>
        <div class="col-md-4"><b>Phone:</b> {{ stop.contactPhone }}</div>
        <div class="col-md-4">
          <b>Collection Amount:</b> ₹{{ stop.amount }}
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-4">
          <b>Distance:</b> {{ stop.segmentDistance }} km
        </div>
        <div class="col-md-4"><b>OTP:</b> {{ stop.otpCode }}</div>
        <div class="col-md-4" *ngIf="stop.deliveredAt">
          <b>Delivered:</b> {{ stop.deliveredAt | date : "short" }}
        </div>
      </div>

      <!-- NEW SECTION ADDED -->
    <div class="row mt-2">
      <div class="col-md-4" *ngIf="stop.status === 3">
        <b>Payment Mode:</b> {{ stop.paymentMode | titlecase }}
      </div>

      <div class="col-md-4" *ngIf="stop.paymentMode === 'online'">
        <b>Receipt:</b><br>

        <img
          [src]="stop.paymentReceipt"
          alt="Payment Receipt"
          style="max-width: 200px; border: 1px solid #ddd; padding: 5px; border-radius: 5px;"
        />
        <br>
      </div>
    </div>


  </div>
  </div>
</div>


</div>
